export default "/images/vendor/flag-icon-css/flags/4x3/is.svg?2dfa14d19684fbe061e4e81ef473aed2";